import * as React from "react";
import styles from "./styles.module.scss";

interface Props {
  loading: boolean;
}

export const Loader = (props: Props) => {
  if (props.loading) {
    return (
      <div className={styles.root}>
        <picture>
          <img
            src="/assets/images/loader.svg"
            className={styles.image}
            alt="ロード中"
          />
        </picture>
      </div>
    );
  } else {
    return null;
  }
};
